import { createReducer, on } from '@ngrx/store';
import { VelocityLimitListInterface } from '../types/velocity-limit-list';
import { defaultVelocityLimitListFilter } from '../types/velocity-limit-list-filter';
import {
  fetchVelocityLimitList,
  loadedVelocityLimitList,
  failedVelocityLimitList,
  updateVelocityLimitListFilter,
  deleteVelocityLimit,
  resetVelocityLimitList,
} from './velocity-limit-list.actions';
import {
  initialVelocityLimitListState,
  VelocityLimitListState,
  initialDataSource,
} from './velocity-limit-list.state';

export const velocityLimitListReducer = createReducer(
  initialVelocityLimitListState,
  on(fetchVelocityLimitList, (state): VelocityLimitListState => ({ ...state })),
  on(loadedVelocityLimitList, (state, action): VelocityLimitListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedVelocityLimitList, (state): VelocityLimitListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(
    updateVelocityLimitListFilter,
    (state, { filter }): VelocityLimitListState => {
      return {
        ...state,
        filter: {
          ...state.filter,
          ...(filter ?? defaultVelocityLimitListFilter),
        },
        dataSource: { ...state.dataSource },
      };
    }
  ),
  on(deleteVelocityLimit, (state, action): VelocityLimitListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: {
        ...state.dataSource,
        rawData: state.dataSource.rawData?.filter(
          (velocityLimit: VelocityLimitListInterface) =>
            velocityLimit.id !== action.id
        ),
      },
    };
  }),
  on(resetVelocityLimitList, (state): VelocityLimitListState => {
    return {
      ...state,
      filter: { ...defaultVelocityLimitListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
